import React from 'react';
import styled from 'styled-components';
export default function FlexWrapper({ children, className, }) {
    return (React.createElement(StyledFlexWrapper, { className: className }, children));
}
const StyledFlexWrapper = styled.div `
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
